import React, { useState } from "react";
import Loader from "../../../../reusableUI/loader";
import { CommonImages } from "../../../../reusableUI/images";
import { MdOutlineZoomOutMap, MdOutlineZoomInMap } from "react-icons/md";
import { FaUndoAlt, FaRedoAlt } from "react-icons/fa";
import { putDocumentVerification } from "../../../../Service/documentVerification";
import { CSSTransition } from "react-transition-group";
import { MdOutlineVerifiedUser } from "react-icons/md";

const Verification = ({
  show,
  onClose,
  onSave,
  aadhar,
  verificationType,
  nursingCertificate,
  phone,
  course,
  statusAadhaar,
  statusCeritify,
  iapCertificate,
  statusIAP,
  role,
}) => {
  const [zoom, setZoom] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [rotation, setRotation] = useState(0);
  const [showDeclineWarning, setShowDeclineWarning] = useState(false);
  const [showVerifyWarning, setShowVerifyWarning] = useState(false);
  const [isDeclining, setIsDeclining] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);
  const [isWho, setIsWho] = useState("");
  const [loading, setLoading] = useState(false);
  // console.log(iapCertificate, verificationType);
  // Zoom In
  const handleZoomIn = () => {
    setZoom((prevZoom) => Math.min(prevZoom + 0.1, 2));
  };

  // Zoom Out
  const handleZoomOut = () => {
    setZoom((prevZoom) => Math.max(prevZoom - 0.1, 1));
  };

  // Rotate Left
  const handleRotateLeft = () => {
    setRotation((prevRotation) => prevRotation - 90);
  };

  // Rotate Right
  const handleRotateRight = () => {
    setRotation((prevRotation) => prevRotation + 90);
  };

  if (!show) {
    return null;
  }
  console.log(role);

  const handleVerified = async (value) => {
    setIsSubmitting(true);
    try {
      let data = {
        docType:
          verificationType === "IAP Certificate" && role === "physiotherapist"
            ? "physiotherapistLicense"
            : "certificate",
        action: value === "verified" ? "accepted" : "rejected",
        phone: phone,
        course: course,
        actionBy: isWho,
        reason: value !== "verified" ? declineReason : "",
      };

      console.log(data);

      let response = await putDocumentVerification(data);
      setLoading(true);
      if (response.error === false) {
        setLoading(false);
        console.log("U", response.data);
        onSave(response.data);
      } else {
        setLoading(false);
        console.error("Verification failed", response.data);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error during verification", error);
    } finally {
      setLoading(false);
      setIsSubmitting(false);
      onClose();
    }
  };

  const renderVerificationContent = () => {
    if (verificationType === "Aadhar Card") {
      return (
        <p className="text-white text-center ml-1">
          Please verify the Aadhaar document.
        </p>
      );
    } else if (verificationType === "Nursing Certificate") {
      return (
        <p className="text-white text-center ml-1">
          Please verify the Nursing Certificate document.
        </p>
      );
    }
  };

  const showVerificationButtons =
    (verificationType === "Aadhar Card" && statusAadhaar === "pending") ||
    (verificationType === "Nursing Certificate" &&
      statusCeritify === "pending") ||
    (verificationType === "IAP Certificate" && statusCeritify === "pending");

  const isVerified =
    (verificationType === "Aadhar Card" && statusAadhaar === "accepted") ||
    (verificationType === "Nursing Certificate" &&
      statusCeritify === "accepted") ||
    (verificationType === "IAP Certificate" && statusCeritify === "accepted");

  const isRejected =
    (verificationType === "Aadhar Card" && statusAadhaar === "rejected") ||
    (verificationType === "Nursing Certificate" &&
      statusCeritify === "rejected");

  const handleDecline = () => {
    setIsWho("");
    setDeclineReason("");
    setShowDeclineWarning(true);
  };

  const handleVerify = () => {
    setIsWho("");
    setDeclineReason("");
    setShowVerifyWarning(true);
  };

  const confirmDecline = async () => {
    if (declineReason.trim() === "") {
      alert("Please provide a reason for rejecting.");
      return;
    }
    setShowDeclineWarning(false);
    setIsDeclining(true);
    await handleVerified("declined");
    setIsDeclining(false);
  };

  const confirmVerify = async () => {
    setShowVerifyWarning(false);
    setIsVerifying(true);
    await handleVerified("verified");
    setIsVerifying(false);
  };

  const cancelDecline = () => {
    setShowDeclineWarning(false);
  };

  const cancelVerify = () => {
    setShowVerifyWarning(false);
  };

  return (
    <>
      {loading ? (
        <div className="fixed inset-0  bg-opacity-50 flex justify-center items-center">
          <Loader loading={loading} />
        </div>
      ) : (
        <CSSTransition in={show} timeout={700} classNames="modal" unmountOnExit>
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="bg-black rounded-lg w-full md:w-[80%] lg:w-[60%] xl:w-[50%] my-10 p-2 sm:p-6 md:p-4 max-h-[85vh]">
              {/* Header */}
              <div className="flex justify-between items-center text-sm mb-3">
                <div className="flex flex-row items-center">
                  <MdOutlineVerifiedUser
                    className="text-blue-500 text-lg"
                    size={22}
                  />
                  {renderVerificationContent()}
                </div>

                <div className="flex items-center">
                  <button
                    onClick={handleZoomIn}
                    className="mr-2 p-2 rounded-lg text-white text-xs py-1 px-2"
                  >
                    <div className="flex items-center gap-1">
                      <MdOutlineZoomInMap size={16} />
                      Zoom In
                    </div>
                  </button>
                  <button
                    onClick={handleZoomOut}
                    className="mr-2 p-2 rounded-lg text-white text-xs py-1 px-2"
                  >
                    <div className="flex items-center gap-1">
                      Zoom Out
                      <MdOutlineZoomOutMap size={16} />
                    </div>
                  </button>
                </div>
                <img
                  src={CommonImages.close}
                  onClick={onClose}
                  className="h-5 w-5 cursor-pointer mr-3"
                  alt="Close"
                />
              </div>
              <div className="border-b border-gray-300 mb-6"></div>

              {/* Zoom Controls */}
              <div className="mb-4 flex flex-row justify-between text-sm">
                <div className="flex items-center">
                  <button
                    onClick={handleRotateLeft}
                    className="mr-2 rounded-lg border border-gray-300 text-white text-xs py-1 px-2"
                  >
                    <div className="flex items-center gap-1">
                      <FaUndoAlt size={12} />
                      <p>Rotate Left</p>
                    </div>
                  </button>

                  <button
                    onClick={handleRotateRight}
                    className="mr-2 rounded-lg border border-gray-300 text-white text-xs py-1 px-2"
                  >
                    <div className="flex items-center gap-1">
                      <FaRedoAlt size={12} />
                      <p>Rotate Right</p>
                    </div>
                  </button>
                </div>
              </div>

              <div className="flex justify-center mb-2">
                <img
                  className="m-4 sm:m-6 md:m-8 max-w-full max-h-full"
                  alt="Document"
                  src={
                    verificationType === "Aadhar Card"
                      ? aadhar
                      : verificationType === "IAP Certificate"
                      ? iapCertificate
                      : nursingCertificate
                  }
                  style={{
                    transform: `scale(${zoom}) rotate(${rotation}deg)`,
                    transition: "transform 0.3s ease",
                    width: "auto",
                    height: "auto",
                    maxWidth: "50%",
                    maxHeight: "220px",
                    borderRadius: "2px",
                  }}
                />
              </div>

              {(showVerificationButtons || isVerified) && (
                <div className="flex flex-row justify-center mb-8 gap-3">
                  {isVerified && (
                    <button
                      className="bg-red-600 rounded-2xl p-2 flex items-center cursor-pointer text-xs w-full sm:w-auto"
                      onClick={handleDecline}
                      disabled={isSubmitting}
                    >
                      <p className="text-white m-2">Decline</p>
                    </button>
                  )}

                  {!isVerified && !isRejected && (
                    <>
                      <button
                        className="bg-red-600 rounded-2xl p-2 flex items-center cursor-pointer text-xs w-full sm:w-auto"
                        onClick={handleDecline}
                        disabled={isSubmitting}
                      >
                        <p className="text-white m-2">Decline</p>
                      </button>
                      <button
                        className="bg-green-500 rounded-2xl p-2 flex items-center cursor-pointer text-xs w-full sm:w-auto"
                        onClick={handleVerify}
                        disabled={isSubmitting}
                      >
                        <p className="text-white m-2">Verify</p>
                      </button>
                    </>
                  )}
                </div>
              )}
            </div>

            {/* Decline Warning Popup */}
            {showDeclineWarning && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
                <div className="bg-white rounded-lg p-6 max-w-sm w-full">
                  <h3 className="text-center text-xl font-bold mb-4">
                    Are you sure?
                  </h3>
                  <p className="text-center mb-6">
                    Do you want to decline this document?
                  </p>

                  {/* Reason input for rejection */}

                  <input
                    className="w-full p-2 border border-gray-300 rounded-md mb-4"
                    rows="4"
                    placeholder="Enter your name"
                    value={isWho}
                    onChange={(e) => setIsWho(e.target.value)}
                  />
                  <textarea
                    className="w-full p-2 border border-gray-300 rounded-md mb-4"
                    rows="4"
                    placeholder="Please provide a reason for rejection"
                    value={declineReason}
                    onChange={(e) => setDeclineReason(e.target.value)}
                  />

                  <div className="flex justify-between">
                    <button
                      className="bg-gray-300 rounded-lg px-4 py-2 text-sm w-1/3"
                      onClick={cancelDecline}
                    >
                      Cancel
                    </button>
                    <button
                      className="bg-red-600 rounded-lg px-4 py-2 text-sm text-white w-1/3"
                      onClick={confirmDecline}
                      disabled={isDeclining}
                    >
                      OK
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Verify Warning Popup */}
            {showVerifyWarning && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
                <div className="bg-white rounded-lg p-6 max-w-sm w-full">
                  <h3 className="text-center text-xl font-bold mb-4">
                    Are you sure?
                  </h3>
                  <p className="text-center mb-6">
                    Do you want to verify this document?
                  </p>
                  <input
                    className="w-full p-2 border border-gray-300 rounded-md mb-4"
                    rows="4"
                    placeholder="Enter your name"
                    value={isWho}
                    onChange={(e) => setIsWho(e.target.value)}
                  />

                  <div className="flex justify-between">
                    <button
                      className="bg-gray-300 rounded-lg px-4 py-2 text-sm w-1/3"
                      onClick={cancelVerify}
                    >
                      Cancel
                    </button>
                    <button
                      className={`rounded-lg px-4 py-2 text-sm w-1/3 
                  ${
                    isVerifying || isWho.trim() === ""
                      ? "bg-gray-200 text-gray-400 cursor-not-allowed" // Disabled state
                      : "bg-green-500 text-white cursor-pointer" // Enabled state
                  }`}
                      onClick={confirmVerify}
                      disabled={isVerifying || isWho.trim() === ""}
                    >
                      OK
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </CSSTransition>
      )}
    </>
  );
};

export default Verification;
